const DefaultContainer = () => import('@/containers/DefaultContainer');
const Dashboard = () => import('./index');

const dashboardRoute = {
  path: '/',
  redirect: '/dashboard',
  component: DefaultContainer,
  children: [
    {
      path: 'dashboard',
      name: 'Dashboard',
      component: Dashboard
    }
  ]
};

export default dashboardRoute;
